import { Component, OnInit } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { MeasureManagementService } from '../measure-management/measure-management.service';
import { MeasureService } from './measure.service';
import { ProfileService } from '../profile/profile.service';
import { AuthService } from 'src/app/core/services/auth/auth.service';

@Component({
  selector: 'app-measure',
  templateUrl: './measure.component.html',
  styleUrls: ['./measure.component.scss']
})
export class MeasureComponent implements OnInit {
  allMeasure;
  type;
  selectedType: number = 0;
  filteredType: number = 0

  page: number = 1;
  pageSize: number = 12;
  collectionSize: number;
  rows: any[];

  userEmail: string;
  token: string;

  constructor(
    private measureService: MeasureService,
    private measureManagementService: MeasureManagementService,
    private gobalFunctionService: GobalFunctionService,
    private profileService: ProfileService,
    private authService: AuthService,
  ) {
    this.token = authService.getToken();
  }

  ngOnInit(): void {
    this.measureService.getAllMeasure(this.selectedType, this.filteredType).pipe(
      switchMap((res) => {
        this.allMeasure = res.result;
        this.refresh();
        // // console.log(this.allMeasure);
        this.gobalFunctionService.setSEO('แบบทดสอบทั้งหมด', 'website', '');

        return this.measureManagementService.getMeasureType().pipe(
          map(res2 => {
            this.type = res2.result;

            if (this.token) {
              this.getProfile();
            }

          })
        )
      }),
      catchError((err) => {
        alert(err.error.message)
        return of(null);
      })
    ).subscribe();
  }

  getProfile() {
    this.profileService.getProfile().pipe(
      map(email => {
        if (email.success) {
          this.userEmail = email.result.EMAIL;
        }
      })
    )
  }

  changeType() {
    this.measureService.getAllMeasure(this.selectedType, this.filteredType).subscribe(res => {
      this.allMeasure = res.result;
      // // console.log(this.allMeasure);
      this.refresh();
    }, (err) => {
      alert(err.error.message)
    })
  }

  refresh() {
    this.collectionSize = this.allMeasure.length;
    this.rows = this.allMeasure
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }
}
